(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bcs-auction-currency-estimates"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  var lastKey = '';
  function selectedCurrency() {
    var nodes = document.querySelectorAll('.bacurr-choiceDesign .ba-chosen');
    for (var i = 0; i < nodes.length; i++) {
      var code = nodes[i].textContent.trim().toUpperCase();
      if (/^[A-Z]{3}$/.test(code)) return code;
    }
    return '';
  }
  function locale() {
    var s = window.Shopify || {};
    return (s.locale || document.documentElement.lang || 'en') + (s.country && !(s.locale || '').includes('-') ? '-' + s.country : '');
  }
  function amountFromText(text) {
    if (!text || !/\d/.test(text)) return null;
    var group = ',', decimal = '.';
    try {
      new Intl.NumberFormat(locale()).formatToParts(12345.6).forEach(function (part) {
        if (part.type === 'group') group = part.value;
        if (part.type === 'decimal') decimal = part.value;
      });
    } catch (e) {}
    var cleaned = text.split(group).join('').split(decimal).join('.').replace(/[^0-9.\-]/g, '');
    if (!/^-?\d+(\.\d+)?$/.test(cleaned)) return null;
    var value = Number(cleaned);
    return Number.isFinite(value) && value >= 0 ? value : null;
  }
  function hide(panel) {
    panel.hidden = true;
    panel.removeAttribute('data-fx-key');
    lastKey = '';
  }
  function update() {
    if (document.hidden) return;
    var panel = document.querySelector('[data-bcs-auction-fx]');
    if (!panel) return;
    var base = panel.dataset.baseCurrency;
    var source = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || base;
    var target = selectedCurrency();
    var nova = window.baCurr;
    var widget = document.querySelector('#codeBlock-auction-widget');
    if (!widget || !target || target === source || source !== base || !nova || !nova.Currency || typeof nova.Currency.convert !== 'function') return hide(panel);
    var rates = nova.Currency.rates || {};
    if (!(Number(rates[source]) > 0) || !(Number(rates[target]) > 0)) return hide(panel);
    var rows = [];
    widget.querySelectorAll('.auction-details-list-item').forEach(function (row) {
      var spans = Array.from(row.children).filter(function (child) { return child.tagName === 'SPAN'; });
      if (spans.length !== 2 || row.querySelector('#codeBlock-no-of-bids')) return;
      var value = amountFromText(spans[1].textContent);
      var label = spans[0].textContent.trim();
      if (value !== null && label) rows.push({ label: label, amount: value });
    });
    if (!rows.length) return hide(panel);
    var input = widget.querySelector('#codeBlock-auction-input-element');
    if (input && /^\d+(\.\d+)?$/.test(input.value)) rows.push({ label: 'Entered bid (' + source + ')', amount: Number(input.value) });
    var converted;
    try {
      var formatter = new Intl.NumberFormat(locale(), { style:'currency', currency:target, currencyDisplay:'code' });
      converted = rows.map(function (row) {
        var value = nova.Currency.convert(row.amount, source, target);
        if (!Number.isFinite(value) || value < 0) throw new Error('Unavailable exchange rate');
        return { label:row.label, amount:formatter.format(value) };
      });
    } catch (e) { return hide(panel); }
    var key = JSON.stringify([source, target, converted]);
    if (key === lastKey && panel.dataset.fxKey === key) { panel.hidden = false; return; }
    var list = panel.querySelector('.bcs-auction-fx__values');
    var fragment = document.createDocumentFragment();
    converted.forEach(function (row) {
      var entry = document.createElement('div');
      var label = document.createElement('dt');
      var value = document.createElement('dd');
      label.textContent = row.label;
      value.textContent = row.amount;
      entry.appendChild(label);
      entry.appendChild(value);
      fragment.appendChild(entry);
    });
    list.replaceChildren(fragment);
    panel.querySelector('.bcs-auction-fx__title').textContent = 'Approximate prices in ' + target;
    panel.querySelector('.bcs-auction-fx__note').textContent = 'Bids and checkout are in ' + source + '. Enter bids in ' + source + '; converted prices are estimates.';
    panel.dataset.fxKey = key;
    panel.hidden = false;
    lastKey = key;
  }
  document.addEventListener('input', function (event) {
    if (event.target && event.target.id === 'codeBlock-auction-input-element') update();
  });
  document.addEventListener('visibilitychange', update);
  document.addEventListener('shopify:section:load', update);
  window.setInterval(update, 1000);
  update();
})();
  } catch(e) { console.error(e); }
})();

})();
